// Content management routes
import Blog from '../../components/Blog.vue'
import Categories from '../../views/Categories.vue'
import BannerList from '../../components/BannerList.vue'
import Keywords from '../../components/Keywords.vue'
import PersonaKeyword from '../../components/PersonaKeyword.vue'
import BannerGPT from '../../components/gpt/BannerGPT.vue'

export default [
  {
    path: '/blogs',
    name: 'Blogs',
    component: Blog,
    meta: { 
      requiresAuth: true,
      title: 'Blog Management'
    }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: Categories,
    meta: { 
      requiresAuth: true,
      title: 'Categories'
    }
  },
  {
    path: '/banners',
    name: 'Banners',
    component: BannerList,
    meta: { 
      requiresAuth: true,
      title: 'Banner Management'
    }
  },
  {
    path: '/keywords',
    name: 'Keywords',
    component: Keywords,
    meta: { 
      requiresAuth: true,
      title: 'Keywords'
    }
  },
  {
    path: '/persona-keywords',
    name: 'PersonaKeyword',
    component: PersonaKeyword,
    meta: { 
      requiresAuth: true,
      title: 'Persona Keywords'
    }
  },
  {
    path: '/banner-gpt',
    name: 'BannerGPT',
    component: BannerGPT,
    meta: {
      requiresAuth: true,
      title: 'AI Banner Generator'
    }
  }
] 